import React from "react";
import * as LucideIcons from "lucide-react";
import { FEATURES } from "../lib/features";

const FeatureCard = ({ feature, testid }) => {
  const Icon = LucideIcons[feature.icon] || LucideIcons.Sparkles;
  return (
    <div
      className="glass-card rounded-xl p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#d4af37]/40 hover:shadow-[0_10px_40px_-10px_rgba(212,175,55,0.18)]"
      data-testid={testid}
    >
      <Icon className="w-7 h-7 mb-5 text-[#d4af37]" strokeWidth={1.5} />
      <h3 className="font-serif text-2xl text-white mb-2 tracking-tight">
        {feature.title}
      </h3>
      <p className="text-white/65 text-sm leading-relaxed">{feature.short}</p>
    </div>
  );
};

const FeatureGrid = ({ items }) => {
  const data = items || FEATURES;
  return (
    <div
      className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      data-testid="features-grid"
    >
      {data.map((f) => (
        <FeatureCard key={f.key} feature={f} testid={`feature-card-${f.key}`} />
      ))}
    </div>
  );
};

export default FeatureGrid;
